import { render } from "./AuthorizationPage.vue?vue&type=template&id=611b1f5c&scoped=true"
import script from "./AuthorizationPage.vue?vue&type=script&lang=js"
export * from "./AuthorizationPage.vue?vue&type=script&lang=js"

import "./AuthorizationPage.vue?vue&type=style&index=0&id=611b1f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611b1f5c"]])

export default __exports__